module.exports = __webpack_public_path__ + "static/media/30OIOS9.1ec27fd0.jpg";